import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, formValues } from 'redux-form';
import * as actions from '../actions';
import { connect } from "react-redux";
import {  Form, Button } from 'reactstrap';
import { ScaleLoader } from 'react-spinners';
import { THE_FIELDS, TAB_LABELS } from './forms/formfields';
import { renderText, renderTextArea, renderSelect, renderDBSelect, renderMultiSelect, renderDatePicker, renderUpload } from '../components/formcomponents';
import GICSSelect from '../components/gicsselect';
import {Tabs, Tab} from 'material-ui/Tabs';
import SwipeableViews from 'react-swipeable-views';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';


var fields;

class Add extends Component {

    constructor(props) {
        super(props);
        this.state = {
            slideIndex: 0,
        };
      }

    handleChange = (value) => {
        this.setState({
            slideIndex: value,
        });
    };

    componentDidMount(){
        if (!this.props.dbtype) {
            this.props.setDBType(localStorage.getItem('dbtype'));
        } else {
            if (this.props.dbtype === 'test'){
                var loaddblist = (this.props.dblist) ? false : true;
                var id = (this.props.initialValues) ? this.props.initialValues.ID : undefined;
                this.props.getDBList(loaddblist, this.props.dbtype,id);
            }
        }
    }

    componentWillReceiveProps (nextProps, nextState) {
        if (this.props.sector !== nextProps.sector && this.props.industrygroup !== nextProps.industrygroup) {
            // console.log("did this");
        } else if (this.props.sector !== nextProps.sector) {
            this.props.change('IndustryGroup','');
        } else if (this.props.industrygroup !== nextProps.industrygroup) {
            this.props.change('Industry','');
        } else if (this.props.industry !== nextProps.industry) {
            this.props.change('SubIndustry','');
        }
    }

    addDefaultsAndSum = (formProps) => {
        var total1 = 0;
        var total2 = 0;
        for (var i =0; i < fields.length; i++){
            if (fields[i].type === 'select') {
                if (!formProps[fields[i].name]) {
                    if (!fields[i].optionsSelect) {
                        formProps[fields[i].name] = fields[i].options[0].value;
                    }
                }
            }
            if (fields[i].shouldSum) {
                if (fields[i].shouldSum === 1) {
                    total1 += parseInt(formProps[fields[i].name],10);
                } else {
                    total2 += parseInt(formProps[fields[i].name],10);
                }
            }
        }
        if (this.props.dbtype === 'idea') {
            formProps.Total = total1;
            formProps.PTotal = total2;
        }
    }

    handleFormSubmit = (formProps) => {
        //Add default values for select inputs if not entered
        this.addDefaultsAndSum(formProps);
        // Call action creator to sign up the user!
        var body = {};

        body.action = (this.props.isModal) ? 'updatemany': 'add';
        if (this.props.isModal) {
            body.action = 'updatemany';
            body.id = formProps.ID;
        } else {
            body.action = 'add';
        }
        body.data = formProps;

        // Code to remove any skipsave fields from the data
        for (var i = 0; i < fields.length; i ++){
            if (fields[i].skipsave){
                delete body.data[fields[i].name]
            }
        }
        this.props.callAPI(this.props.dbtype,body);
    }

    renderField = (formProps) => {
        switch (formProps.type) {
            case 'text':
                return renderText(formProps);
            case 'textarea':
                return renderTextArea(formProps);
            case 'select':
                return renderSelect(formProps);
            case 'dbselect':
                return renderDBSelect(formProps, this.props.dblist);
            case 'multiselect':
                return renderMultiSelect(formProps);
            case 'files':
                if (this.props.initialValues) {
                    return renderUpload(formProps,this.props.initialValues['ID']);
                }
                return '';
            case 'date':
                return renderDatePicker(formProps);
            default:
                return '';
        }
    }

    renderButton = (pristine, submitting) => {
        if (this.props.loading) {
            return (
                <div className='sweet-loading'>
                    <ScaleLoader
                         color={'#36D7B7'}
                         loading={this.props.loading}
                     />
                </div>
            );
            // return(<Button color="success" disabled={true} type="submit">Signing Up</Button>);
        } else {
            return(<Button color="success" disabled={pristine || submitting} type="submit">Save</Button>);
        }
    }

    required = value => (value ? undefined : 'Required')
    email = value =>
      value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
        ? 'Invalid email address'
        : undefined

    createValidateArray = (tests) => {
        if (tests) {
            var returnarray = [];
            if (tests.required) { returnarray.push(this.required)};
            if (tests.email) { returnarray.push(this.email)};
            return returnarray;
        }
    }

    renderFields = (tab) => {
        if (this.props.dbtype) {
            if (!fields) {
                fields = THE_FIELDS[this.props.dbtype];
            }
            var returnjsx = [];
            for (var i = 0; i < fields.length; i++) {
                if ((tab === -1 || fields[i].tab === tab) && (fields[i].add === "always" || (fields[i].add === "modal"))) {
                    returnjsx.push (<Field {...this.createFieldProps(fields[i])}/>);
                }
            }
            return returnjsx;
        }
    }

    createFieldProps = (field) => {
        var props = {};
        props.key = field.name;
        props.add = field.add;
        props.name = field.name;
        props.type = field.type;
        props.label = field.label;
        props.options = field.options;
        if (field.optionsSelect) { props.optionsSelect = field.optionsSelect};
        props.validate = this.createValidateArray(field.validate);
        if (field.type === 'gicsselect') {
            props.component = formValues({parent: field.parent})(GICSSelect);
        } else {
            props.component = this.renderField;
        }
        return props;
    }


    capitalizeFirstLetter = (string) => {
        if (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

    renderHeader = () => {
        if (!this.props.isModal) {
            return (
                <div>
                    <div className="spacer-lg"></div>
                    <h3 className="add-header">{`New ${this.capitalizeFirstLetter(this.props.dbtype)}`}</h3>
                    <hr className="my-2" />
                </div>
            );
        }
    }

    renderTabLabels = () => {
        var tabs = TAB_LABELS[this.props.dbtype];
        return (tabs.map((label,index) =>
            <Tab key={index} label={label} style={{color: '#22B48B', textAlign: 'left'}} value={index} />
        ));
    }

    renderSwipeableViews = () => {
        var tabs = TAB_LABELS[this.props.dbtype];
        return (tabs.map((label,index) =>
            <div key={index}>
                {this.renderFields(index)}
            </div>
        ));
    }

    renderTabs = () => {
        if (this.props.dbtype) {
            if (TAB_LABELS[this.props.dbtype].length > 0) {
                return (
                    <div>
                        <MuiThemeProvider>
                            <Tabs onChange={this.handleChange} value={this.state.slideIndex}
                                    inkBarStyle={{background: '#22B48B'}} tabItemContainerStyle={{background: 'White'}} >
                                {this.renderTabLabels()}
                            </Tabs>
                        </MuiThemeProvider>
                        <SwipeableViews animateHeight index={this.state.slideIndex} onChangeIndex={this.handleChange}>
                            {this.renderSwipeableViews()}
                        </SwipeableViews>
                    </div>
                );
            } else {
                return this.renderFields(-1);
            }
        }
    }

    render() {
        const {handleSubmit,pristine, submitting} = this.props;
        if (this.props.form_loading){
            return (
                <div className="add">
                    {this.renderHeader()}
                    <div className='sweet-loading'>
                        <ScaleLoader
                             color={'#36D7B7'}
                             loading={this.props.form_loading}
                        />
                    </div>
                </div>
            )
        } else {
            return (
                <div className="add">
                    {this.renderHeader()}
                    <Form onSubmit={handleSubmit(this.handleFormSubmit)}>
                        {this.renderTabs()}
                        <div className="spacer-lg"></div>
                        <div>
                            {this.renderButton(pristine, submitting)}
                        </div>
                    </Form>
                </div>
            )
        }
    }
}
const reduxSignup =  reduxForm({
  form: 'Add'
})(Add);

const selector = formValueSelector('Add');

function mapStateToProps(state) {
    return {
        loading: state.app.loading,
        form_loading: state.app.form_loading,
        dbtype: state.app.dbtype,
        dblist: state.app.dblist,
        sector: selector(state, 'Sector'),
        industrygroup: selector(state, 'IndustryGroup'),
        industry: selector(state, 'Industry'),
        subindustry: selector(state, 'SubIndustry')
    };
}

export default connect(mapStateToProps, actions)(reduxSignup);



// WEBPACK FOOTER //
// ./src/pages/add.js